import React, { useState, useEffect, useRef } from "react";
import { Avatar, Box, Button, Card, Divider, Grid, Popover, TextField, Typography } from "@mui/material";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import Picker from "emoji-picker-react";
import { useSelector } from "react-redux";
import Comment from "./Comment";
import CircularProgress from '@mui/material/CircularProgress';

const SingleComment = ({ feedPostComments, handleSnakbarClick, reactPost, updateComment, handleEmojiClick, idEmoji, openEmoji, showPicker, handleEmojiClose, isLoading,
  deleteComment, reportComment, setCommentText, commentText, setIsTextFieldFocused, setShowEmoji, handleTextFieldBlur, isTextFieldFocused, onEmojiClick, handleComment }) => {

  const userData = useSelector((state) => state?.user?.userListName)

  const handleTextFieldFocus = () => {
    setIsTextFieldFocused(true);
    setShowEmoji(true);
  };

  const handleCancelClick = () => {
    setCommentText('');
    setIsTextFieldFocused(false);
  };


  return (
    <Grid className='grid2' item lg={4} md={5} sm={12} xs={12}>
      <Box sx={{ p: 1, mt: 1, backgroundColor: '#ECEFF1', display: 'flex' }}>
        <Box sx={{ color: '#546E7A' }}><ChatBubbleOutlineIcon /></Box>
        <Box sx={{ color: '#546E7A', mx: 1 }}><Typography variant='subtitle2'>Comments</Typography></Box>
      </Box>
      <Box sx={{}}>
        <Card>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <Box sx={{ mt: 1, mr: 1 }}>
                  <Avatar
                    src={userData.userAvatar}
                    alt={(userData?.userName)}
                    sx={{
                      backgroundColor: 'transparent !Important',
                      height: '40px',
                      boxShadow: 'none',
                      width: '40px',
                      '& .MuiAvatar-img': {
                        height: '40px',
                        width: '40px',
                        textAlign: 'center',
                        objectFit: 'cover',
                        color: 'transparent',
                        textIndent: '10000px'
                      }
                    }} />
                </Box>
              </Grid>
              <Grid item xs={10}>
                <Box sx={{ '.MuiTextField-root': { width: '100%' } }}>
                  <TextField
                    id="outlined-basic"
                    name="commentText"
                    variant="outlined"
                    placeholder="Write a Comment"
                    size="medium"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    onFocus={handleTextFieldFocus}
                    onBlur={handleTextFieldBlur}
                  />
                </Box>
                {isTextFieldFocused && (
                  <Box sx={{ my: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={2}>
                        <Box sx={{ color: '#6995D3', cursor:'pointer' }} onClick={handleEmojiClick}>
                          <EmojiEmotionsIcon />
                        </Box>
                        <Popover
                          id={idEmoji}
                          open={openEmoji}
                          anchorEl={showPicker}
                          onClose={handleEmojiClose}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                          }}
                        >
                          <Picker Style={{ width: '100%', padding: '6px' }} onEmojiClick={onEmojiClick} />
                        </Popover>
                      </Grid>

                      <Grid item xs={10}>
                        <Box sx={{ justifyContent: 'flex-end', display: 'flex' }}>
                          <Button variant="text" size="small" onClick={handleCancelClick}>
                            Cancel
                          </Button>
                          <Button variant="contained" size="small" onClick={handleComment} sx={{ ml: 2 }} disabled={isLoading}>
                            {!isLoading ? 'Comment' :
                              <CircularProgress size={23}  color="inherit" />}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ my: 1 }}>
            <Divider />
          </Box>
          <Box>
            {feedPostComments.map((comment, index) => (
              <Comment
                key={comment.id}
                comment={comment}
                index={index}
                handleSnakbarClick={handleSnakbarClick}
                updateComment={updateComment}
                reactPost={reactPost}
                deleteComment={deleteComment}
                reportComment={reportComment}
                feedPostComments={feedPostComments}
              />
            ))}
          </Box>
        </Card>

      </Box>
    </Grid>
  );
}

export default SingleComment;
